export default function (elementSelector: string) {
  setTimeout(() => {
    const el = document?.querySelector(elementSelector) as HTMLSelectElement;
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, 10);
}
